var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWater = function SvgWater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M6 15.293C6 12.9 9.927 6.439 12.051 3.26a.198.198 0 0 1 .335.01c1.806 3.039 5.22 9.243 5.586 12.023.236 1.797-.958 5.707-5.747 5.707C7.915 21 6 18.366 6 15.293Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M8.604 14.942c-.047 1.035.332 3.148 2.214 3.323"
  })));
};
export default SvgWater;